angular.module('NumbersEditor').controller('postDrawCertificateController', [
    '$scope', '$routeParams', '$rootScope', 'EventFactory', '$location', '$filter', 'appInfoFactory',
    function ($scope, $routeParams, $rootScope, eventFactory, $location, $filter, appInfoFactory) {

        function getSubTitle() {
            var sportCode = $routeParams.sportCode === "49" ? "49" : "Irish Lottery";
            var eventNo = parseInt($routeParams.no);
            var draw = "";
            if (sportCode === "49" && eventNo === 1)
                draw = "Lunch Time";
            else if (sportCode === "49" && eventNo === 2)
                draw = "Tea Time";
            var date = $filter("date")($routeParams.startDate, "fullDate");

            return sportCode + " - " + draw + " - (" + date + ")";
        }

        function newPreDrawCertificate() {
            $scope.PreDrawCertificate = {
                AdjudicatorName: "",
                InitialsForQ1: "",
                InitialsForQ2: "",
                InitialsForQ3: "",
                InitialsForQ4: "",
                InitialsForQ5: "",
                InitialsForQ6: "",
                InitialsForQ7: "",
                Q8DrawFirst: "",
                Q8DrawSecond: "",
                Q8DrawThrird: "",
                Q8DrawFourth: "",
                Q8DrawFifth: "",
                Q8DrawSixth: "",
                Q8DrawBooster: "",
                Q8DrawHour: "",
                Q8DrawMinute: "",
                Q8DrawSeconds: "",
                InitialsForQ9: "",
                Q10Comments: "",
                SignedForDeloitte: "",
                SignedForSis: "",
                InitialsForQ3B: ""
            }

            appInfoFactory.getDateTime()
                .success(function (dateTime) {
                    var today = new Date(JSON.parse(dateTime));
                    $scope.PreDrawCertificate.CertificationDate = today;
                }).error(function (error) {
                    $.message(error.ExceptionMessage, MessageType.Error);
                });
        }

        function mapPreDrawCertificate(preDrawCertificate) {
            $scope.PreDrawCertificate = {
                AdjudicatorName: preDrawCertificate.AdjudicatorName,
                CertificationDate: preDrawCertificate.CertificationDate,
                InitialsForQ1: preDrawCertificate.InitialsForQ1,
                InitialsForQ2: preDrawCertificate.InitialsForQ2,
                InitialsForQ3: preDrawCertificate.InitialsForQ3,
                InitialsForQ4: preDrawCertificate.InitialsForQ4,
                InitialsForQ5: preDrawCertificate.InitialsForQ5,
                InitialsForQ6: preDrawCertificate.InitialsForQ6,
                InitialsForQ7: preDrawCertificate.InitialsForQ7,
                Q8DrawFirst: preDrawCertificate.Q8DrawFirst,
                Q8DrawSecond: preDrawCertificate.Q8DrawSecond,
                Q8DrawThrird: preDrawCertificate.Q8DrawThrird,
                Q8DrawFourth: preDrawCertificate.Q8DrawFourth,
                Q8DrawFifth: preDrawCertificate.Q8DrawFifth,
                Q8DrawSixth: preDrawCertificate.Q8DrawSixth,
                Q8DrawBooster: preDrawCertificate.Q8DrawBooster,
                Q8DrawHour: preDrawCertificate.Q8DrawHour,
                Q8DrawMinute: ("0" + preDrawCertificate.Q8DrawMinute).slice(-2),
                Q8DrawSeconds: ("0" + preDrawCertificate.Q8DrawSeconds).slice(-2),
                InitialsForQ9: preDrawCertificate.InitialsForQ9,
                Q10Comments: preDrawCertificate.Q10Comments,
                SignedForDeloitte: preDrawCertificate.SignedForDeloitte,
                SignedForSis: preDrawCertificate.SignedForSis,
                InitialsForQ3B: preDrawCertificate.InitialsForQ3B
            }
        }

        function getPreDrawCertificate() {
            eventFactory.GetPreDrawCertificate($routeParams.eventId)
                .success(function (preDrawCertificate) {
                    if (preDrawCertificate === "null")
                        newPreDrawCertificate();
                    else
                        mapPreDrawCertificate(preDrawCertificate);
                })
                .error(function (error) { $.message(error.ExceptionMessage, MessageType.Error); });
        }

        function init() {
            $rootScope.SetAppTitle("Certificate", getSubTitle());
            getPreDrawCertificate();
        }



        init();

        $scope.SavePostDrawCertificate = function () {
            eventFactory.SavePreDrawCertificate($routeParams.eventId, $scope.PreDrawCertificate)
                .success(function (event) {
                    $.message("Draw is now completed", MessageType.Success);
                    $location.path("/");
                })
                .error(function (error) {
                    if (error.ModelState) $.message(JSON.stringify(error.ModelState), MessageType.Error);
                    else $.message(error.ExceptionMessage, MessageType.Error);
                });
        }

        $scope.PostDrawWeight = function () {
            $location.path("/postdrawweight/" + $routeParams.eventId);
        }
    }
]);